@let userCartShortInfo = userCartShortInfo$ | async;

@if (extensionBlock()) {
  <div class="mobile-menu-extra">
    <ng-container *ngTemplateOutlet="extensionBlock()"></ng-container>
  </div>
}

@if (!hideTabsWhenExtension()) {
  <p-tabs [(value)]="activeTabValue" scrollable [showNavigators]="false">
    <p-tablist [class.menu-extra]="extensionBlock()">
      @for (tab of navigationMenuItems; track tab.value) {
        <p-tab [value]="tab.value" [routerLink]="tab.route" [queryParams]="tab.queryParams">
          @if (tab.value === NavigationMenu.cart) {
            <p-overlay-badge
              [value]="userCartShortInfo?.productsAmount?.toString() ?? '0'"
              badgeSize="small"
            >
              <ng-container
                *ngTemplateOutlet="tabIcon; context: { tab: tab }"
              ></ng-container>
            </p-overlay-badge>
          } @else {
            <ng-container
              *ngTemplateOutlet="tabIcon; context: { tab: tab }"
            ></ng-container>
          }
          <span class="menu-title small">{{ tab.title | transloco }}</span>
        </p-tab>
      }
    </p-tablist>
  </p-tabs>
}

<ng-template #tabIcon let-tab="tab">
  @if (tab.icon) {
    <ng-container
      *ngTemplateOutlet="menuIcon; context: { icon: tab.icon }"
    ></ng-container>
  } @else if (tab.iconId) {
    <ng-container
      *ngTemplateOutlet="menuIconCustom; context: { iconId: tab.iconId }"
    ></ng-container>
  }
</ng-template>

<ng-template #menuIcon let-icon="icon">
  <i [class]="icon + ' menu-icon'"></i>
</ng-template>

<ng-template #menuIconCustom let-iconId="iconId">
  <b2b-portal-tiss-icon
    [iconId]="iconId"
    size="large"
    class="menu-icon"
  ></b2b-portal-tiss-icon>
</ng-template>
